import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";
import { adminValidation } from "../library/service";
import Popup from '../components/Popup';

const User = () => {
  const [fileName, setFileName] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [response, setResponse] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [admin, setAdmin] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    authUser();
    adminAuth();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");

    if (!token) {
      navigate("/");
      return;
    }
  };

  const adminAuth = async () => {
    const authorized = await adminValidation();
    console.log("authorised:", authorized);
    if (!authorized) {
      // Redirect to login page if the token has expired
      navigate('/');
    } else if (authorized && authorized.data.is_admin) {
      setAdmin(true);
    } else {
      navigate("/unAuthorized");
    }
  };


  const handleChange = (event) => {
    let uploadedFile = event.target.files[0];
    let fileName = uploadedFile.name;
    console.log('uploaded_file', uploadedFile);
    console.log('filename', fileName);
    setFileName(fileName);
    setAttachment(uploadedFile);
    setDisabled(false);
  };

  const sendToBackend = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("files", attachment);
    console.log("attachment", attachment);
    const token = window.sessionStorage.getItem("JWTtoken");
    var config = {
      method: "post",
      url: `${backendBookartUrl}userUpload`,
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      data: formData,
    };
    axios(config)
      .then((response) => {
        let status = response.status;
        let responseData = response.data;
        console.log(responseData);
        if (status === 200 || status === 201) {
          setResponse(responseData);
        }
        else {
          setIsError(true);
          handleShowPopup('Upload User', response.data.message);
        }
      })
      .catch((error) => {
        setIsError(true);
        handleShowPopup('Upload User', "Something wrong happened. Try again!");
        console.log(error);
      });
  };

  const backToUserUpload = () => {
    setResponse(null);
    setFileName(null);
    setAttachment(null);
  }

  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  if (!admin) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <div className="container min-height60">
          {/* <MainHeader />
        <div className="container back-home">
          <Link to="/admin">
            <button className="es-link colored font-16" type="submit">
              <svg viewBox="0 0 54 128" height="16" width="11">
                <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
              </svg>
              &nbsp;Back To Home
            </button>
          </Link>
        </div> */}

          {response ? (
            <div className="container user-admin">
              {isError ? (
                <Popup
                  title={popupTitle}
                  message={popupMessage}
                  show={showPopup}
                  handleClose={handleClosePopup}
                />
              ) : (
                <div>
                  <h2>Uploaded Successfully</h2>
                  <table className="table table-borderless margin-top-30">
                    <thead className="cart-table-header sticky-table-head">
                      <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="color-light-ash font-16">Onboard Success</td>
                        <td className="color-light-ash font-16">
                          {response.onboard_success.split(",").map((el, index) => (
                            <div key={index}>{el}</div>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td className="color-light-ash font-16">Onboard Failed</td>
                        <td className="color-light-ash font-16">
                          {response.onboard_failed.split(",").map((el, index) => (
                            <div key={index}>{el}</div>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td className="color-light-ash font-16">Existing User Count</td>
                        <td className="color-light-ash font-16">{response.existing_userCount}</td>
                      </tr>
                      <tr>
                        <td className="color-light-ash font-16">Existing User Email List</td>
                        <td className="color-light-ash font-16">
                          {response.existing_userList.split(",").map((el, index) => (
                            <div key={index}>{el}</div>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td className="color-light-ash font-16">Total Users</td>
                        <td className="color-light-ash font-16">{response.totalUsers}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="margin-top-30">
                    <button className="es-button primary" onClick={backToUserUpload}>
                      <svg viewBox="0 0 54 128" height="16" width="11">
                        <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
                      </svg>
                      &nbsp;Back to user upload
                    </button>
                  </div>

                </div>
              )}
            </div>
          ) : (
            <div className="container user-admin">
              <h2>User Upload</h2>
              <form onSubmit={sendToBackend}>
                <p>
                  <label
                    htmlFor="upload-user"
                    className="pointer es-button secondary upload-label"
                  >
                    <span>Choose File</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 112 128"
                      height="24"
                      width="21"
                    >
                      <path d="M21 10v10h80v60.953L74.06 108H31V86H21v32h57.216L111 85.082V10zm72 70V70H63v30h10V80zm-72-2h10V47.756c8 7.73 5.6 5.886 13.052 13.712l7.243-6.894-25.293-26.577L.707 54.574l7.243 6.894C17.28 51.662 17 52.828 21 47.756z" />
                    </svg>
                  </label>
                  <input
                    className="pointer"
                    id="upload-user"
                    type="file"
                    name="file"
                    autoComplete="off"
                    required
                    onChange={handleChange}
                  />
                </p>
                <p id="file_name_upload">{fileName}</p>
                <p>
                  <button
                    className="es-button primary"
                    type="submit"
                    disabled={disabled}
                  >
                    Submit
                  </button>
                </p>
              </form>
            </div>
          )}
          {/* <Footer /> */}
        </div>
      </React.Fragment>
    );
  }
};

export default User;